
const digest = '69415a23030bee3819afb1372a1cbbe2b7080cad3b903af80a89df72b0990f1d';
const classes = {"wrapper":"_wrapper_1rzhb_1","controls":"_controls_1rzhb_7","formWrapper":"_formWrapper_1rzhb_18"};
const css = `._wrapper_1rzhb_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-right: 1px solid #ebedf3;
}
._wrapper_1rzhb_1 ._controls_1rzhb_7 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-top: 0;
}
._wrapper_1rzhb_1 ._formWrapper_1rzhb_18 {
  padding: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  